import { createContext, useContext } from 'react'
import { TimelineKinds } from './Timeline'

export interface TimelineContextValue {
  kind?: TimelineKinds
}

export const TimelineContext = createContext<TimelineContextValue>({})

export const useTimelineContext = (): TimelineContextValue => {
  return useContext(TimelineContext)
}
